let project = import.meta.env.VITE_PROJECT;
console.log("Loading App Project v2", project);

if (project === "miles") {
  import("./main.miles");
}
else if (project === "dance") {
  import("./main.dance");
}
else if (project === "poem") {
  import("./main.poem");
}